"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toJsonForSchema = void 0;
const zod_1 = require("zod");
const toJsonForSchema = (schema) => zod_1.z.preprocess((val) => {
    if (typeof val === 'string')
        return JSON.parse(val);
    return val;
}, schema.passthrough());
exports.toJsonForSchema = toJsonForSchema;
//# sourceMappingURL=toJsonForSchema.js.map